/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";

const { state, callbacks, actions } = store("frs-blocks/testimonials", {
  state: {
    get isCurrent() {
      const context = getContext();
      return context.currentIndex == context.index;
    },

    get positionText() {
      const context = getContext();
      if (context.currentIndex == context.index) {
        return `Testimonial ${context.index + 1} of ${context.testimonialCount}`;
      }
      return '';
    }
  },

  actions: {
    // Helper function to focus the current dot after DOM updates
    focusCurrentDot() {
      setTimeout(() => {
        const currentDot = document.querySelector(`.testimonials-nav-dot[aria-selected="true"]`);
        if (currentDot) {
          currentDot.focus();
        }
      }, 0);
    },

    setCurrentIndex() {
      const context = getContext();
      context.currentIndex = context.index;
      actions.focusCurrentDot();
    },

    decrementIndex() {
      const context = getContext();
      context.currentIndex =
        context.currentIndex == 0
          ? context.testimonialCount - 1
          : context.currentIndex - 1;
    },

    incrementIndex() {
      const context = getContext();
      context.currentIndex =
        context.currentIndex >= context.testimonialCount - 1
          ? 0
          : context.currentIndex + 1;
    },

    handleKeyDown(event) {
      const context = getContext();
      const key = event.key;

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        event.preventDefault();
        context.currentIndex =
          context.currentIndex == 0
            ? context.testimonialCount - 1
            : context.currentIndex - 1;
        actions.focusCurrentDot();
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        event.preventDefault();
        context.currentIndex =
          context.currentIndex >= context.testimonialCount - 1
            ? 0
            : context.currentIndex + 1;
        actions.focusCurrentDot();
      } else if (key === 'Home') {
        event.preventDefault();
        context.currentIndex = 0;
        actions.focusCurrentDot();
      } else if (key === 'End') {
        event.preventDefault();
        context.currentIndex = context.testimonialCount - 1;
        actions.focusCurrentDot();
      }
    },

    handleButtonKeyDown(event) {
      const key = event.key;

      if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        event.target.click();
      }
    },
  }
});
